import "core-js/modules/es.array.push.js";
import dayjs from "dayjs";
export default {
  data() {
    return {
      search_data: {
        queryBeginTime: dayjs().subtract(24, "hours").format("YYYY-MM-DD") + " 00:00:00",
        queryEndTime: dayjs().format("YYYY-MM-DD") + " 23:59:59"
      }
    };
  },
  props: {
    plotId: {
      type: String,
      default: ""
    },
    number: {
      type: String,
      default: ""
    }
  },
  mounted() {
    // this.getData();
    this.getWeatherTrendData();
  },
  methods: {
    // 获取数据
    async getData() {
      let params = {
        plotId: this.plotId
      };
      let {
        code,
        data
      } = await this.$api.getMaterialUseDataList(params);
      if (code == "200") {
        console.log(data, "投入品数据");
        let seedCount = this.getChartsData(data, "seedCount");
        let fertilizerCount = this.getChartsData(data, "fertilizerCount");
        let othersCount = this.getChartsData(data, "othersCount");
        let pesticideCount = this.getChartsData(data, "pesticideCount");
        let xData = this.getChartsData(data, "month");
        this.initChart(seedCount, fertilizerCount, pesticideCount, othersCount, xData);
      }
    },
    // 获取不同字段，组成数组
    getChartsData(array, prop) {
      let arr = [];
      for (let i = 0; i < array.length; i++) {
        arr.push(array[i][prop]);
      }
      return arr;
    },
    async getWeatherTrendData(number) {
      let params = {
        number: this.number,
        ...this.search_data,
        pageSize: "10000"
      };
      let {
        rows,
        code
      } = await this.$api.getGreenhouseListData(params);
      if (code == "200") {
        this.listData = rows;
        let xData = this.getChartsData(rows, "createTime");
        let soilTempData = this.getChartsData(rows, "soilTemperature");
        let soilHumData = this.getChartsData(rows, "soilHumidity");
        this.initChart2(0, xData, soilTempData, soilHumData, ["温度", "湿度"]);
      }
      console.log(rows, "气象站历史数据");
    },
    initChart2(index, xData, yData1, yData, legendData) {
      console.log(index, xData, yData, legendData, "this.$refs.echarts");
      let airTempDom = document.querySelector("#plot-inputUsage-chart");
      var chartDom = airTempDom;
      if (index == 0) chartDom = airTempDom;
      console.log(chartDom, "chartDom");
      var myChart = this.$echarts.init(chartDom);
      // 定义颜色
      const color = "#19E3B4";

      // 设置阴影渐变
      const areaStyle = {
        normal: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: color
          }, {
            offset: 1,
            color: "rgba(25, 227, 180, 0)"
          }])
        }
      };

      // 配置项
      const option = {
        // 设置曲线的颜色
        color: ["#19E3B4"],
        grid: {
          top: "20%",
          // 顶部留白
          left: "10%",
          // 左侧留白
          right: "10%",
          // 右侧留白
          bottom: "20%" // 底部留白
        },

        legend: {
          top: 10,
          data: legendData,
          textStyle: {
            color: "#fff",
            // 设置文字颜色为白色
            fontSize: 9 // 设置文字大小为7px
          }
        },

        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            color: "#ffffff" // x 轴刻度文字颜色
          },

          axisLine: {
            lineStyle: {
              color: "#ffffff" // x 轴线颜色
            }
          }
        },

        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff" // x 轴刻度文字颜色
          },

          axisLine: {
            lineStyle: {
              color: "#ffffff" // x 轴线颜色
            }
          }
        },

        // 设置阴影渐变
        series: [{
          name: "温度",
          type: "line",
          smooth: true,
          // 线是圆滑的、
          showAllSymbol: true,
          symbolSize: 5,
          showSymbol: false,
          data: yData1,
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: "rgba(34, 255, 204, 0.2)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgba(34, 255, 204, 1)" // 100% 处的颜色
              }],

              global: false // 缺省为 false
            }
          },

          lineStyle: {
            color: "#22FFCC"
          }
        }, {
          name: "湿度",
          type: "line",
          smooth: true,
          // 线是圆滑的、
          showAllSymbol: true,
          // symbolSize: 5,
          showSymbol: false,
          data: yData,
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: "rgba(34, 154, 255, 0.2)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgba(34, 154, 255, 1)" // 100% 处的颜色
              }],

              global: false // 缺省为 false
            }
          },

          lineStyle: {
            color: "#229AFF"
          }
        }]
      };
      option && myChart.setOption(option);
    },
    initChart(seedCount, fertilizerCount, pesticideCount, othersCount, xData) {
      console.log("打印");
      var chartDom = document.querySelector("#plot-inputUsage-chart");
      // var chartDom = this.$refs.echarts;
      var myChart = this.$echarts.init(chartDom);
      // 定义数据
      const data = {
        categories: xData,
        seriesData: [{
          name: "农药",
          data: pesticideCount
        }, {
          name: "肥料",
          data: fertilizerCount
        }, {
          name: "种子",
          data: seedCount
        }, {
          name: "其他辅料",
          data: othersCount
        }],
        legendColors: ["#3e15db", "#287ce7", "#f4cf3d", "#30c6dc"]
      };

      // 配置项
      const option = {
        color: ["linear-gradient(to top, #163750, " + data.legendColors[0] + ")", "linear-gradient(to top, #163750, " + data.legendColors[1] + ")", "linear-gradient(to top, #163750, " + data.legendColors[2] + ")", "linear-gradient(to top, #163750, " + data.legendColors[3] + ")"],
        grid: {
          top: "20%",
          // 顶部留白
          left: "10%",
          // 左侧留白
          right: "10%",
          // 右侧留白
          bottom: "20%" // 底部留白
        },

        xAxis: {
          type: "category",
          data: data.categories,
          axisLabel: {
            color: "#ffffff" // x 轴刻度文字颜色
          },

          axisLine: {
            lineStyle: {
              color: "#ffffff" // x 轴线颜色
            }
          }
        },

        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff" // y 轴刻度文字颜色
          },

          axisLine: {
            lineStyle: {
              color: "#ffffff" // y 轴线颜色
            }
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: "#ffffff" // y 轴网格线颜色
            }
          }
        },

        legend: {
          top: 10,
          textStyle: {
            color: "#ffffff",
            // legend 文字颜色
            fontSize: 10 // legend 文字大小
          },

          itemWidth: 10,
          // legend 图例标记宽度
          itemHeight: 10,
          // legend 图例标记高度
          // itemGap: 10, // legend 图例项之间的间距
          data: data.seriesData.map((category, index) => ({
            name: category.name,
            itemStyle: {
              color: data.legendColors[index]
            }
          }))
        },
        series: data.seriesData.map((item, index) => ({
          name: item.name,
          type: "bar",
          data: item.data,
          barGap: "10%",
          // 柱状图之间的间距
          barWidth: 4,
          // 柱状图的宽度
          itemStyle: {
            barBorderRadius: 10,
            // 柱状图的圆角
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "#163750"
            }, {
              offset: 1,
              color: data.legendColors[index]
            }]) // 渐变色设置
          },

          emphasis: {
            itemStyle: {
              borderColor: data.legendColors[index],
              // 高亮状态下的边框颜色
              borderWidth: 2 // 高亮状态下的边框宽度
            }
          }
        }))
      };

      option && myChart.setOption(option);
    }
  }
};